<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="400px"
    :innerScroll="false"
    :loading="loading"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form ref="addForm" :model="addForm" :rules="rules" label-width="80px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="文件名:" prop="fileId">
            <el-select v-model="addForm.fileId" placeholder="请选择" clearable>
              <!-- <el-option label="全部" value=""></el-option> -->
              <el-option v-for="item in importFileList" :key="item.fileId" :label="item.fileName" :value="item.fileId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </q-dialog>
</template>

<script>
export default {
  name: "CRUDEdit",
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    importFileList: {
      type: Array,
      default: [],
    },
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "删除";
    },
    name() {
      return this.$store.state.user.name;
    },
  },
  data() {
    return {
      loading: false,
      addForm: {},
      rules: {
        fileId: [
          { required: true, message: '不能为空', trigger: 'change' }
        ],
      },
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },

    async onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if(!valid) return
        this.$confirm("是否确认删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.loading = true;
            this.$q.dataImport
              .activityDel({ fragment: [this.addForm.fileId] })
              .then((res) => {
                if (res.code == 200) {
                  let text = this.title + "成功";
                  this.$message.success(text);
                } else {
                  this.$message.error(res.message);
                }
                this.isVisible = false;
                this.$emit('del')
              })
              .finally(() => {
                this.loading = false;
              });
          })
          .catch(() => {});
      });
    },
    async init() {},
  },
};
</script>

<style lang="stylus" scoped>

>>> .el-input--small .el-input__inner, >>> .el-input--suffix .el-input__inner, >>> .el-input--suffix {
  height: 32px;
  line-height: 32px;
  width: 170px !important;
}

>>> .el-date-editor.el-input {
  width: 170px
}

>>> .el-select .el-input .el-select__caret {
  height: 32px;
  line-height: 32px;
}

>>> .el-dialog {
  margin: 35vh auto !important
}

>>> .el-textarea .el-input__count {
    background: transparent;
    height: 28px;
}

.input-number {
  >>> .el-input__inner {
    text-align: left;
  }
}

>>> .el-form-item__content .textTips {
  cursor: pointer
  height: 40px
  overflow: hidden
  white-space: nowrap;
  text-overflow: ellipsis
}

.remark >>> .el-form-item__label {
  line-height: 26px
}
</style>
